import React from 'react';
import { useTranslation } from 'next-i18next';
import IconButton from './components/IconButton/index.js';

const Remove = ({ item, onRemove, icon = 'icon-trash' }) => {
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    // Do not show Remove icon if product is a gift
    if (item.gift)
        return null;
    return (React.createElement(IconButton, { btnClassName: icon, title: `${tButton('remove')}: ${item.product.name}`, "aria-label": `${tButton('remove')}: ${item.product.name}`, onClick: onRemove }));
};

export { Remove as R };
//# sourceMappingURL=Remove-yBvNmlSV.js.map
